import styles from "./Section.module.scss";

export const Section = ({ children }: { children: React.ReactNode }) => {
  if (!children) return null;

  return <section className={styles.section}>{children}</section>;
};
